import { observer } from 'mobx-react-lite'
import { PayoutSplitAllocator } from '@/features/jobs/details/components/PayoutSplitAllocator'
import { SplitAssist } from '@/features/jobs/details/components/PayoutSplitAllocator/SplitAssist'
import { type PayoutSplitAllocatorViewModel } from './PayoutSplitAllocatorViewModel'
import { AllocationInputViewContainer } from '@/features/jobs/details/components/PayoutSplitAllocator/AllocationInputView/AllocationInputViewContainer'

export interface PayoutSplitAllocatorContainerProps {
  vm: PayoutSplitAllocatorViewModel
}

export const PayoutSplitAllocatorContainer = observer(
  function PayoutSplitAllocatorContainer({
    vm,
  }: PayoutSplitAllocatorContainerProps) {
    return (
      <PayoutSplitAllocator
        splitAssist={
          vm.allocations.length > 1 && (
            <SplitAssist
              canFillRemainder={vm.canFillRemainder}
              onSplitEqually={vm.splitEqually}
              onFillRemainder={vm.fillRemainder}
            />
          )
        }
      >
        {vm.allocations.map((allocationVm, i) => (
          <AllocationInputViewContainer
            key={i}
            vm={allocationVm}
            isRemovable={vm.canRemoveAllocation}
          />
        ))}
      </PayoutSplitAllocator>
    )
  },
)
